import React from 'react';
import { logout } from './Login';

const AdditionalButton = props => {
    const { label } = props;

    return (
        <div className="input-group pt-2">
            <button className="btn btn-lg btn-outline-secondary btn-block mx-auto" onClick={() => logout()}>
                {label}
            </button>
        </div>
    )
}

const CancelButton = props => {
    return <AdditionalButton label="Cancelar"/>
    
}

const ExitButton = props => {
    return <AdditionalButton label="Sair"/>
}

export { CancelButton, ExitButton };